export default "__VITE_ASSET__CeyzN7bY__"